module.exports = __webpack_public_path__ + "static/media/sticky-note.690c7048.svg";